import type { KeenSliderInstance } from 'keen-slider'
import range from 'lodash/range'
import type { FunctionComponent, MutableRefObject } from 'react'
import type { KeenSliderOptionTypes } from '../hooks/useResponsiveStackGridOptions'

const sliderBarClasses = (
  optionType: KeenSliderOptionTypes,
  active?: boolean
) => {
  const base = ['w-full', 'rounded-none', 'md:h-px-8']
  if (
    optionType === 'CurrentPressArticles' ||
    optionType === 'PropImageSlider' ||
    optionType === 'WorkingForAccentro' ||
    optionType === 'RecommendedFlats'
  ) {
    base.push('h-px-6')
  } else {
    base.push('h-px-4')
  }
  base.push(active ? 'bg-accentroGray-full' : 'bg-accentroGray-100')
  return base.join(' ')
}

const sliderBarContainerClasses = (optionType: KeenSliderOptionTypes) => {
  const base = ['flex', 'justify-center']
  if (
    optionType === 'CurrentPressArticles' ||
    optionType === 'WorkingForAccentro'
  ) {
    base.push('mr-px-40', 'lg:mr-px-64', 'space-x-px-16', 'w-full')
  }
  if (optionType === 'PropImageSlider') base.push('mr-px-40', 'lg:mr-px-80')
  if (optionType === 'MoreFlats' || optionType === 'RecommendedFlats')
    base.push('w-full')
  return base.join(' ')
}

export const SliderBottomNavigation: FunctionComponent<
  React.PropsWithChildren<{
    slider: MutableRefObject<KeenSliderInstance | null>
    optionType: KeenSliderOptionTypes
    slidesPerView: number
    slideIndex: number
    isArticle?: boolean
  }>
> = ({ slider, slidesPerView, slideIndex, optionType }) => {
  const sliderKeys =
    slider && slider.current
      ? range(slider.current.track.details?.slides.length)
      : []

  return (
    <div className={sliderBarContainerClasses(optionType)}>
      {sliderKeys.map((idx) => {
        if (idx > Math.ceil(sliderKeys.length - slidesPerView)) return null

        return (
          <button
            className={sliderBarClasses(optionType, slideIndex === idx)}
            key={idx}
            onClick={() => slider.current?.moveToIdx(idx)}
          />
        )
      })}
    </div>
  )
}
